import { createSelector } from 'reselect'
// import { List } from 'immutable'
const leaveGenerationSelector = state => state.get('leaveGeneration')

export const getIsFetching = createSelector(
  leaveGenerationSelector,
  leaveGenerationImmutable => {
    const leaveGeneration = leaveGenerationImmutable.toJS()
    return leaveGeneration.leaveGenerationGet.isFetching
    || leaveGeneration.leaveGenerationEdit.isFetching
    || leaveGeneration.leaveGenerationExport.isFetching
    || leaveGeneration.leaveGenerationUserExport.isFetching
    || leaveGeneration.leaveGenerationImport.isFetching
    || leaveGeneration.leaveGenerationExport.isFetching
    || leaveGeneration.leaveGenerationUserExport.isFetching
  }
)
export const getLeaveGenerationData = createSelector(
  leaveGenerationSelector,
  leaveGenerationImmutable => {
    const leaveGeneration = leaveGenerationImmutable.toJS()
    return leaveGeneration.leaveGenerationGet.leaveGeneration
  }
)
export const editLeaveGenerationData = createSelector(
  leaveGenerationSelector,
  leaveGenerationImmutable => {
    const leaveGeneration = leaveGenerationImmutable.toJS()
    return leaveGeneration.leaveGenerationEdit
  }
)
export const exportLeaveGenerationData = createSelector(
  leaveGenerationSelector,
  leaveGenerationImmutable => {
    const leaveGeneration = leaveGenerationImmutable.toJS()
    return leaveGeneration.leaveGenerationExport.url
  }
)
export const exportLeaveGenerationUserData = createSelector(
  leaveGenerationSelector,
  leaveGenerationImmutable => {
    const leaveGeneration = leaveGenerationImmutable.toJS()
    return leaveGeneration.leaveGenerationUserExport.url
  }
)
export const importLeaveGenerationData = createSelector(
  leaveGenerationSelector,
  leaveGenerationImmutable => {
    const leaveGeneration = leaveGenerationImmutable.toJS()
    return leaveGeneration.leaveGenerationImport.importResult
  }
)
export const redirectGeneration = createSelector(
  leaveGenerationSelector,
  leaveGenerationImmutable => {
    const leaveGeneration = leaveGenerationImmutable.toJS()
    return ({
      redirect: (leaveGeneration.leaveGenerationGet.redirect
      || leaveGeneration.leaveGenerationEdit.redirect
      || leaveGeneration.leaveGenerationExport.redirect
      || leaveGeneration.leaveGenerationUserExport.redirect
      || leaveGeneration.leaveGenerationImport.redirect
      || leaveGeneration.leaveGenerationExport.redirect
      || leaveGeneration.leaveGenerationUserExport.redirect),
      isAuthenticated: (leaveGeneration.leaveGenerationGet.isAuthenticated
      || leaveGeneration.leaveGenerationEdit.isAuthenticated
      || leaveGeneration.leaveGenerationExport.isAuthenticated
      || leaveGeneration.leaveGenerationUserExport.isAuthenticated
      || leaveGeneration.leaveGenerationImport.isAuthenticated
      || leaveGeneration.leaveGenerationExport.isAuthenticated
      || leaveGeneration.leaveGenerationUserExport.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/leave-generation/leave-generation-selector.js